<template>
    <div class="page-content">
        <PageHeader title="代码位管理">
            <template slot="extra">
                <el-button type="primary" icon="el-icon-plus" @click="() => handleAddClick()">代码位</el-button>
                <el-button type="primary" icon="el-icon-download" @click="() => handleDownload()">导出代码位</el-button>
            </template>
        </PageHeader>
        <div class="page-scroll-box">
            <div class="filter-box">
                <el-row>
                    <el-col :span="8" class="filter-item">
                        <label class="label">应用名称</label>
                        <el-select
                            v-model="params.media_name"
                            placeholder="不限"
                            clearable
                            multiple
                            collapse-tags
                            filterable
                            @change="handleSearch"
                        >
                            <el-option
                                v-for="item in appOptions"
                                :key="item.name"
                                :label="item.name"
                                :value="item.name">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="8" class="filter-item">
                        <label class="label">代码位ID</label>
                        <el-input
                            v-model="params.adslot_id"
                            placeholder="不限"
                            clearable
                            @change="handleSearch"
                        />
                    </el-col>
                    <el-col :span="8" class="filter-item">
                        <label class="label">代码位名称</label>
                        <el-input
                            v-model="params.adslot_name"
                            placeholder="不限"
                            clearable
                            @change="handleSearch"
                        />
                    </el-col>
                    <el-col :span="8" class="filter-item">
                        <label class="label">代码位类型</label>
                        <el-select
                            v-model="params.adslot_type"
                            placeholder="不限"
                            clearable
                            multiple
                            collapse-tags
                            @change="handleSearch"
                        >
                            <el-option
                                v-for="item in adslotTypeOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="8" class="filter-item">
                        <label class="label">竞价类型</label>
                        <el-select
                            v-model="params.bidding_type"
                            placeholder="不限"
                            clearable
                            @change="handleSearch"
                        >
                            <el-option
                                v-for="item in biddingTypeOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="8" class="filter-item">
                        <label class="label">审核状态</label>
                        <el-select
                            v-model="params.audit"
                            placeholder="全部"
                            clearable
                            multiple
                            @change="handleSearch"
                        >
                            <el-option
                                v-for="item in codeListStatus"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>
            </div>
            <ShowTable
                :listData="listData"
                :pageShow="true"
                :pageSize="params.page_size"
                @pageChange="pageChangeHandle"
                @pageSizeChange="pageSizeChangeHandle"
                @actionClick="handleClick"
            />
        </div>
    </div>
</template>

<script>
import PageHeader from '@/components/PageHeader'
import ShowTable from '@/components/ShowTable'
import { getCodeList, getAllAppList, getCodeTypeList, downloadCodeList } from '@/apis/flow.js';
import { BiddingTypes, codeListStatus } from '@/common/constant'

export default {
    components: {
        PageHeader,
        ShowTable
    },
    data() {
        return {
            params: {
                audit: [],
                media_name: '',
                page: 1,
                page_size: 20,
            },
            appOptions: [],
            adslotTypeOptions: [],
            biddingTypeOptions: [...BiddingTypes],
            codeListStatus: [...codeListStatus],
            listData: {
                head: [
                    {
                        key: 'id',
                        name: '代码位ID',
                        align: 'center',
                    },
                    {
                        key: 'adslot_name',
                        name: '代码位名称',
                        align: 'center',
                    },
                    {
                        key: 'media_name',
                        name: '所属应用',
                        align: 'center',
                    },
                    {
                        key: 'adslot_attribute_type_txt',
                        name: '代码位类型',
                        align: 'center',
                    },
                    {
                        key: 'bidding_type_txt',
                        name: '竞价类型',
                        align: 'center',
                    },
                    {
                        key: 'audit_txt',
                        name: '审核状态',
                        align: 'center',
                        type: 'colored-text',
                        getColor: (row) => {
                            // 0：待审核；1：通过；2：未通过； 3：永不再审； 4：下线
                            if (row.audit === 0) return '#FFBB00';
                            if ([2, 3].includes(row.audit)) return '#FF5035';
                            if (row.audit === 4) return '#989CA2';
                        }
                    },
                    {
                        key: 'action',
                        name: '操作',
                        type: 'action',
                        align: 'center',
                        actionList: [
                            {
                                key: 'edit',
                                name: '编辑'
                            },
                        ]
                    },
                ],
                list: [],
                currentPage: 1,
                total: 0,
            }
        }
    },
    created() {
        if (this.$route.query && this.$route.query.appName) {
            this.params.media_name = [this.$route.query.appName];
        }
        
        this.getCodeTypeList()
        this.getAllAppList();
        this.getList()
    },
    methods: {
        handleSearch() {
            this.params.page = 1;
            this.getList();
        },
        async getList() {
            let audit = '';
            if (this.params.audit && this.params.audit.length) {
                audit = this.params.audit.join();
            }
            const {data = {}} = await getCodeList({
                ...this.params,
                audit,
                is_qunion: 1
            });
            this.$set(this.listData, 'list', data.list)
            this.$set(this.listData, 'total', data.total)
            this.$set(this.listData, 'currentPage', this.params.page)
        },
        async getAllAppList() {
            const {data = []} = await getAllAppList({ status: 0 })
            this.appOptions = data
        },
        async getCodeTypeList() {
            const {data = {}} = await getCodeTypeList();
            this.adslotTypeOptions = [
                ...(data.options || [])
            ]
        },
        pageChangeHandle(page) {
            this.params.page = page;
            this.getList(page);
        },
        pageSizeChangeHandle(size) {
            this.params.page_size = size;
            this.params.page = 1;
            this.getList();
        },
        handleClick(btn, row) {
            const key = btn.key;
            switch (key) {
                case 'edit':
                    this.handleAddClick({
                        id: row.id,
                        type: row.adslot_attribute_type,
                    })
                    break;
                default:
                    break;
            }
        },
        handleAddClick(query = {}) {
            this.$router.push({
                name: 'codeAdd',
                query
            })
        },
      
        // 下载代码位
        async handleDownload() {
          let audit = '';
          if (this.params.audit && this.params.audit.length) {
            audit = this.params.audit.join();
          }
          
          const {data = {}} = await downloadCodeList({
            ...this.params,
            audit,
            is_qunion: 1
          });

          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const blobUrl = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = '代码位列表.xlsx';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(blobUrl);
        }
    }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/css/page.scss";
@import "~@/assets/css/filter.scss";
</style>
<style lang="scss">
.el-tag.el-tag--info {
    max-width: 100px;
}
</style>
